// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Globals
 */


/* Custom default button */
.btn-light,
.btn-light:hover,
.btn-light:focus {
    color: #333;
    text-shadow: none;
    /* Prevent inheritance from \`body\` */
}


/*
 * Base structure
 */

/* body {
  text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5);
  box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);
} */

.cover-container {
    max-width: 60em;
}


/*
 * Header
 */

.nav-masthead .nav-link {
    color: rgba(255, 255, 255, .5);
    border-bottom: .25rem solid transparent;
}

.nav-masthead .nav-link:hover,
.nav-masthead .nav-link:focus {
    border-bottom-color: rgba(255, 255, 255, .25);
}

.nav-masthead .nav-link+.nav-link {
    margin-left: 1rem;
}

.nav-masthead .active {
    color: #fff;
    border-bottom-color: #fff;
}

.bd-placeholder-img {
    font-size: 1.125rem;
    text-anchor: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

@media (min-width: 768px) {
    .bd-placeholder-img-lg {
        font-size: 3.5rem;
    }
}

.b-example-divider {
    width: 100%;
    height: 3rem;
    background-color: rgba(0, 0, 0, .1);
    border: solid rgba(0, 0, 0, .15);
    border-width: 1px 0;
    box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.b-example-vr {
    flex-shrink: 0;
    width: 1.5rem;
    height: 100vh;
}

.bi {
    vertical-align: -.125em;
    fill: currentColor;
}

.nav-scroller {
    position: relative;
    z-index: 2;
    height: 2.75rem;
    overflow-y: hidden;
}

.nav-scroller .nav {
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 1rem;
    margin-top: -1px;
    overflow-x: auto;
    text-align: center;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
}

.btn-bd-primary {
    --bd-violet-bg: #712cf9;
    --bd-violet-rgb: 112.520718, 44.062154, 249.437846;

    --bs-btn-font-weight: 600;
    --bs-btn-color: var(--bs-white);
    --bs-btn-bg: var(--bd-violet-bg);
    --bs-btn-border-color: var(--bd-violet-bg);
    --bs-btn-hover-color: var(--bs-white);
    --bs-btn-hover-bg: #6528e0;
    --bs-btn-hover-border-color: #6528e0;
    --bs-btn-focus-shadow-rgb: var(--bd-violet-rgb);
    --bs-btn-active-color: var(--bs-btn-hover-color);
    --bs-btn-active-bg: #5a23c8;
    --bs-btn-active-border-color: #5a23c8;
}

.bd-mode-toggle {
    z-index: 1500;
}

.bd-mode-toggle .dropdown-menu .active .bi {
    display: block !important;
}



.custom-textarea-wrapper {
    display: flex;
    position: relative;
    font-family: monospace;
    width: 100%;
}

.line-numbers,
.extra-info {
    position: absolute;
    top: 0;
    white-space: pre;
    pointer-events: none;
    color: #aaa;
    padding-top: 8px;
    font-family: monospace;
    line-height: 1.5em;
}

.line-numbers {
    left: 0;
    padding-left: 8px;
}

.extra-info {
    right: 0;
    padding-right: 8px;
    text-align: left;
}



.custom-textarea {
    width: 100%;
    background-color: RGBA(28, 32, 36);
    /* background-color: black; */
    padding: 8px;
    box-sizing: border-box;
    /* background: none; */
    font-family: monospace;
    /* border: 1px solid #ccc; */
    line-height: 1.5em;
    /* margin-left: 60px; */
    /* Adjust to match line-numbers width */
    /* margin-right: 200px; */
    /* Adjust to match extra-info width */
    resize: none;
    overflow: hidden;
}


textarea {
    color: white;
    background-color: black;
}

body {
    font-family: 'Proxima Nova', sans-serif;
}

html,
body {
    height: 100%;
    margin: 0;
}

.shadow-layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);
    pointer-events: none;
    z-index: -1;
}

h3,
h4 {
    font-weight: 100;
}

textarea {
    border: none;
    outline: none;
}

.toast {
    background-color: #333;
}







/* Transition animation for swiping effect */
.swipe-enter-active, .swipe-leave-active {
    transition: transform 0.5s ease;
  }
  .swipe-enter, .swipe-leave-to {
    transform: translateX(100%);
  }

.assembly_input {
    background-color: RGBA(28, 32, 36);
    border: none;
    outline: none;
    color: white;
    border:  solid 1px 'white';
    outline: 1px;
    outline-color: white;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;EAEE;;;AAGF,0BAA0B;AAC1B;;;IAGI,WAAW;IACX,iBAAiB;IACjB,oCAAoC;AACxC;;;AAGA;;EAEE;;AAEF;;;GAGG;;AAEH;IACI,eAAe;AACnB;;;AAGA;;EAEE;;AAEF;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,gCAAgC;IAChC,mBAAmB;IACnB,wFAAwF;AAC5F;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;IACvB,kDAAkD;;IAElD,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,0CAA0C;IAC1C,qCAAqC;IACrC,0BAA0B;IAC1B,oCAAoC;IACpC,+CAA+C;IAC/C,gDAAgD;IAChD,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,kCAAkC;IAClC,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,uBAAuB;IACvB,uCAAuC;IACvC,yBAAyB;IACzB,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;;;;;;;AAQA,4CAA4C;AAC5C;IACI,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;;AAEF;IACI,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":["/*\n * Globals\n */\n\n\n/* Custom default button */\n.btn-light,\n.btn-light:hover,\n.btn-light:focus {\n    color: #333;\n    text-shadow: none;\n    /* Prevent inheritance from `body` */\n}\n\n\n/*\n * Base structure\n */\n\n/* body {\n  text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5);\n  box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);\n} */\n\n.cover-container {\n    max-width: 60em;\n}\n\n\n/*\n * Header\n */\n\n.nav-masthead .nav-link {\n    color: rgba(255, 255, 255, .5);\n    border-bottom: .25rem solid transparent;\n}\n\n.nav-masthead .nav-link:hover,\n.nav-masthead .nav-link:focus {\n    border-bottom-color: rgba(255, 255, 255, .25);\n}\n\n.nav-masthead .nav-link+.nav-link {\n    margin-left: 1rem;\n}\n\n.nav-masthead .active {\n    color: #fff;\n    border-bottom-color: #fff;\n}\n\n.bd-placeholder-img {\n    font-size: 1.125rem;\n    text-anchor: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n}\n\n@media (min-width: 768px) {\n    .bd-placeholder-img-lg {\n        font-size: 3.5rem;\n    }\n}\n\n.b-example-divider {\n    width: 100%;\n    height: 3rem;\n    background-color: rgba(0, 0, 0, .1);\n    border: solid rgba(0, 0, 0, .15);\n    border-width: 1px 0;\n    box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);\n}\n\n.b-example-vr {\n    flex-shrink: 0;\n    width: 1.5rem;\n    height: 100vh;\n}\n\n.bi {\n    vertical-align: -.125em;\n    fill: currentColor;\n}\n\n.nav-scroller {\n    position: relative;\n    z-index: 2;\n    height: 2.75rem;\n    overflow-y: hidden;\n}\n\n.nav-scroller .nav {\n    display: flex;\n    flex-wrap: nowrap;\n    padding-bottom: 1rem;\n    margin-top: -1px;\n    overflow-x: auto;\n    text-align: center;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n}\n\n.btn-bd-primary {\n    --bd-violet-bg: #712cf9;\n    --bd-violet-rgb: 112.520718, 44.062154, 249.437846;\n\n    --bs-btn-font-weight: 600;\n    --bs-btn-color: var(--bs-white);\n    --bs-btn-bg: var(--bd-violet-bg);\n    --bs-btn-border-color: var(--bd-violet-bg);\n    --bs-btn-hover-color: var(--bs-white);\n    --bs-btn-hover-bg: #6528e0;\n    --bs-btn-hover-border-color: #6528e0;\n    --bs-btn-focus-shadow-rgb: var(--bd-violet-rgb);\n    --bs-btn-active-color: var(--bs-btn-hover-color);\n    --bs-btn-active-bg: #5a23c8;\n    --bs-btn-active-border-color: #5a23c8;\n}\n\n.bd-mode-toggle {\n    z-index: 1500;\n}\n\n.bd-mode-toggle .dropdown-menu .active .bi {\n    display: block !important;\n}\n\n\n\n.custom-textarea-wrapper {\n    display: flex;\n    position: relative;\n    font-family: monospace;\n    width: 100%;\n}\n\n.line-numbers,\n.extra-info {\n    position: absolute;\n    top: 0;\n    white-space: pre;\n    pointer-events: none;\n    color: #aaa;\n    padding-top: 8px;\n    font-family: monospace;\n    line-height: 1.5em;\n}\n\n.line-numbers {\n    left: 0;\n    padding-left: 8px;\n}\n\n.extra-info {\n    right: 0;\n    padding-right: 8px;\n    text-align: left;\n}\n\n\n\n.custom-textarea {\n    width: 100%;\n    background-color: RGBA(28, 32, 36);\n    /* background-color: black; */\n    padding: 8px;\n    box-sizing: border-box;\n    /* background: none; */\n    font-family: monospace;\n    /* border: 1px solid #ccc; */\n    line-height: 1.5em;\n    /* margin-left: 60px; */\n    /* Adjust to match line-numbers width */\n    /* margin-right: 200px; */\n    /* Adjust to match extra-info width */\n    resize: none;\n    overflow: hidden;\n}\n\n\ntextarea {\n    color: white;\n    background-color: black;\n}\n\nbody {\n    font-family: 'Proxima Nova', sans-serif;\n}\n\nhtml,\nbody {\n    height: 100%;\n    margin: 0;\n}\n\n.shadow-layer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);\n    pointer-events: none;\n    z-index: -1;\n}\n\nh3,\nh4 {\n    font-weight: 100;\n}\n\ntextarea {\n    border: none;\n    outline: none;\n}\n\n.toast {\n    background-color: #333;\n}\n\n\n\n\n\n\n\n/* Transition animation for swiping effect */\n.swipe-enter-active, .swipe-leave-active {\n    transition: transform 0.5s ease;\n  }\n  .swipe-enter, .swipe-leave-to {\n    transform: translateX(100%);\n  }\n\n.assembly_input {\n    background-color: RGBA(28, 32, 36);\n    border: none;\n    outline: none;\n    color: white;\n    border:  solid 1px 'white';\n    outline: 1px;\n    outline-color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
